import api from '@/lib/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function uploadFile(file, category = 'misc') {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post(`/admin/upload?category=${encodeURIComponent(category)}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.url.startsWith('http') ? data.url : `${BACKEND_URL}${data.url}`;
}

export async function uploadFiles(files, category, onProgress) {
  const list = Array.from(files || []).filter(f => f.type.startsWith('image/'));
  const urls = [];
  for (let i = 0; i < list.length; i++) {
    try { urls.push(await uploadFile(list[i], category)); } catch { /* skip failed file */ }
    onProgress?.(i + 1, list.length);
  }
  return urls;
}

export const fmtDate = (d, opts) => {
  if (!d) return '';
  const dt = new Date(/^\d{4}-\d{2}-\d{2}$/.test(d) ? `${d}T00:00:00` : d);
  return isNaN(dt) ? d : dt.toLocaleDateString('en-US', opts);
};
